import { ApolloClient, NormalizedCacheObject, useMutation, useQuery } from '@apollo/client';

import ApolloClientService from '../../shared/services/ApolloClientService';
import Config from '../../shared/config';
import GraphQL from '../gql';
import SiteSettings from '../models/SiteSettings';
import { SiteSettingsData } from '../gql-types';

let siteAdminApolloClient: ApolloClient<NormalizedCacheObject> = null;

function useSiteSettings() {
  if (!siteAdminApolloClient) {
    siteAdminApolloClient = ApolloClientService.create(Config.SITE_ADMIN_GQL);
  }
  const {
    loading: loadingSiteSettings,
    error: siteSettingsError,
    data: siteSettingsData
  } = useQuery<SiteSettingsData>(
    GraphQL.Query.SITE_SETTINGS,
    {
      client: siteAdminApolloClient,
      fetchPolicy: 'network-only'
    }
  );

  const [
    _saveSiteSettings,
    { loading: savingSiteSettings, error: saveSiteSettingsError, data }
  ] = useMutation(GraphQL.Mutation.SET_SITE_SETTINGS, {
    refetchQueries: [{ query: GraphQL.Query.SITE_SETTINGS }],
    awaitRefetchQueries: true
  });

  const saveSiteSettings = (siteSettings: SiteSettings) => {
    _saveSiteSettings({
      variables: {
        input: siteSettings
      }
    });
  };

  return {
    loadingSiteSettings,
    siteSettingsError,
    siteSettingsData,
    saveSiteSettings,
    savingSiteSettings,
    saveSiteSettingsError
  };
}

export default useSiteSettings;
